((window) => {
    function handleSelectSingleNode(domWraper, nodeStr = "") {
        const nodeList = nodeStr.split('/');
        if (nodeList.length == 1) {
            return domWraper.querySelector(nodeList[0])
        } else {
            domWraper = domWraper.querySelector(nodeList[0]);
            if (!domWraper) {
                throw new Error(`This node was not found : ${nodeList[0]}`)
            }
            nodeList.shift();
            return handleSelectSingleNode(domWraper, nodeList.join('/'))
        }
    }
    class GoogleMapPoint {
        constructor({ lat, lng, key = null, isSuccess = true, errorMessage = "", formattedAddress = "" }) {
            this.lat = lat;
            this.lng = lng;
            this.key = key;
            this.isSuccess = isSuccess;
            this.errorMessage = errorMessage;
            this.formattedAddress = formattedAddress;
        }
    }
    function getStatusCodeDesc(statusCode) {
        statusCode = statusCode.trim().toUpperCase()
        let result = "";

        switch (statusCode) {
            case "OK":
                break;
            case "ZERO_RESULTS":
                result = "indicates that the geocode was successful but returned no results. This may occur if the geocoder was passed a non-existent address.";
                break;
            case "OVER_QUERY_LIMIT":
                result = "indicates that you are over your quota.";
                break;
            case "REQUEST_DENIED":
                result = "indicates that your request was denied.";
                break;
            case "INVALID_REQUEST":
                result = "generally indicates that the query (address, components or latlng) is missing.";
                break;
            case "UNKNOWN_ERROR":
                result = " indicates that the request could not be processed due to a server error. The request may succeed if you try again.";
                break;
        }
        return result;
    }
    class googleMap {
        constructor(dbJson) {
            this.storeFinder = dbJson;
            // this.storeFinder = null;
            this.EARTH_RADIUS = 6378.137; //Earth radius KM
            this.DEFAULT_LONGITUDE_LATITUDE = "-999d";
            this.googleApiKey = "AIzaSyDtSpMYGKCxPIJELMfVPYyh8KnrLuo8rbs";
            this.googleUrl = `https://maps.googleapis.com/maps/api/geocode/xml`;
            this.initStoreFinder()
        }
        async initStoreFinder() {
            // this.storeFinder = dbJson;
        }
        async getModifiStoresFromLatLng(lat, lng) {
            var result = await this.getAddressFromLatLng(lat, lng);
            return await this.LoadModifiStores(result);
        }
        async getAddressFromLatLng(lat, lng) {
            const requestUrl = `${this.googleUrl}?latlng=${lat.toString()},${lng.toString()}&key=${this.googleApiKey}`;
            let success = false;
            let errorMsg = "";
            let formatAddress = "";
            const responseStr = await fetch(requestUrl).then(v => v.text());
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(responseStr, "text/xml");
            const statusCode = handleSelectSingleNode(xmlDoc, 'status').innerHTML.trim();
            errorMsg = getStatusCodeDesc(statusCode)
            if (statusCode.toUpperCase() == 'OK') {
                formatAddress = handleSelectSingleNode(xmlDoc, "result/formatted_address").innerHTML.trim();
                success = true;
            } else {
                errorMsg = responseStr
            }
            return new GoogleMapPoint({ lat, lng, isSuccess: success, errorMessage: errorMsg, formattedAddress: formatAddress });
        }
        async getModifiStoresFromAddress(fullAddress) {
            const result = await this.getGeocodingByAddress(fullAddress);
            let test = await this.LoadModifiStores(result)
            return await this.LoadModifiStores(result)
        }
        getFormatFullAddress(address = "", city = "", state = "", zipCode = "") {
            let fullAddress = "";
            fullAddress += address.trim().replace(" ", "+");
            if (city.trim().Length > 0) {
                if (fullAddress.trim().Length > 0) fullAddress += ",+";
                fullAddress += city.trim().replace(" ", "+");
            }
            if (state.trim().Length > 0) {
                if ((city.trim().Length == 0 && fullAddress.Length > 0) || city.trim().Length > 0) fullAddress += ",+";
                fullAddress += state.trim().replace(" ", "+");
                if (zipCode.trim().Length > 0) {
                    fullAddress += string.Concat("+", zipCode.trim());
                }
            }
            else if (zipCode.trim().Length > 0) {
                if ((city.trim().Length == 0 && fullAddress.Length > 0) || city.trim().Length > 0) fullAddress += ",+";
                fullAddress += zipCode.trim();
            }
            return fullAddress;
        }
        async _getFormatFullAddress(fullAddress) {
            var result = await this.getGeocodingByAddress(fullAddress);
            return this.LoadModifiStores(result);
        }
        async _getGeocodingByAddress() {
            return await this.getGeocodingByAddress(this.getFormatFullAddress(address, city, state, zipCode));
        }
        async getGeocodingByAddress(fullAddress) {
            const requestUrl = `${this.googleUrl}?address=${fullAddress}&key=${this.googleApiKey}`;
            let lat = "-999.0d";
            let lng = "-999.0d";
            let success = false;
            let errorMsg = "";
            let formatAddress = "";

            const responseStr = await fetch(requestUrl).then(v => v.text());
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(responseStr, "text/xml");
            const statusCode = handleSelectSingleNode(xmlDoc, 'status').innerHTML.trim();
            errorMsg = getStatusCodeDesc(statusCode);
            if (statusCode.toUpperCase() == "OK") {
                formatAddress = handleSelectSingleNode(xmlDoc, "result/formatted_address").innerHTML.trim()
                const locationNode = handleSelectSingleNode(xmlDoc, "result/geometry/location");
                lat = handleSelectSingleNode(locationNode, "lat").innerHTML.trim() * 1;
                lng = handleSelectSingleNode(locationNode, "lng").innerHTML.trim() * 1;
                success = true;
            } else {
                const errorMes = responseStr
            }
            return new GoogleMapPoint({ lat, lng, isSuccess: success, errorMessage: errorMsg, formattedAddress: formatAddress });
        }
        async LoadModifiStores(currentData) {
            currentData.key = this.googleApiKey;
            if (!currentData.isSuccess) {
                return currentData
            }
            const ModifiStoresList = [];

            console.log(this.storeFinder)
            this.storeFinder.forEach((item, index) => {
               // item.StoreNo = item.StoreNumber.replace(/\D/g, '');
                item.Longitude = item.Longitude * 1;
                item.Latitude = item.Latitude * 1;
                if (item.Longitude == this.DEFAULT_LONGITUDE_LATITUDE && item.Latitude == this.DEFAULT_LONGITUDE_LATITUDE) {
                    var temp = this._getGeocodingByAddress(item.StreetAddress, item.City, item.State, item.Zip);
                    if (temp.isSuccess) {
                        item.Longitude = temp.lng;
                        item.Latitude = temp.lat;
                        //update db
                        // DB.ExecuteSQL("UPDATE [storefinder] SET Longitude=" + item.longitude + ",Latitude=" + item.latitude + " WHERE ID=" + DB.RSFieldInt(rs, "ID"));
                    }
                }
                if (item.Longitude != this.DEFAULT_LONGITUDE_LATITUDE && item.Latitude != this.DEFAULT_LONGITUDE_LATITUDE) {

                    item.Distance = this.getDistanceFromGoogleMapPoint(currentData, new GoogleMapPoint({ lat: item.Latitude, lng: item.Longitude }));
                }
                else {
                    item.Distance = -1;
                }
                ModifiStoresList.push(item)
            })
            ModifiStoresList.sort((a, b) => {
                if (a.isCLStore && !b.isCLStore) return -1;
                if (!a.isCLStore && b.isCLStore) return 1;
                return a.distance - b.distance;
            });
            if (ModifiStoresList.length > 0) {
                const firstCLStore = ModifiStoresList.find(item => item.isCLStore);
                if (firstCLStore) {
                    const index = ModifiStoresList.indexOf(firstCLStore);
                    if (index > 0) {
                        ModifiStoresList.splice(index, 1);
                        ModifiStoresList.unshift(firstCLStore);
                    }
                }
            }
            currentData.StoreList = ModifiStoresList;
            return currentData
        }
        getDistanceFromGoogleMapPoint(p1, p2) {
            let radLat1 = p1.lat * (Math.PI / 180);
            let radLat2 = p2.lat * (Math.PI / 180);

            let a = radLat1 - radLat2;
            let b = p1.lng * (Math.PI / 180) - p2.lng * (Math.PI / 180);
            let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
            s = s * this.EARTH_RADIUS;
            s = Math.round(s * 10000) / 10000;   //km
            //Kilometers to Miles 
            s = s * 0.621371192;

            return s;  //Miles
        }
    }
    window.googleMap = googleMap
})(window)